import React from 'react';
import { formatDate } from '../../utils/date';
const DatePickerField = ({ id, name, label, value, onChange, required = false, disabled = false }) => (
  <div className="floating-label-group">
    <input type="date" id={id} name={name} value={formatDate(value)}
      onChange={(e) => onChange?.({ target: { name: name ?? id, value: e.target.value } })}
      required={required} disabled={disabled} placeholder=" " className="floating-input floating-date" />
    <label htmlFor={id} className="floating-label">{label}{required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}</label>
  </div>
);
export default DatePickerField;
